// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_Dow","colMin":"styles_colMin__t7h2g"};